"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "m14.373 11.8.042.002.036.007.018.127.016-.12.035.005.04.012.043.02.09.057.035.026 2.058 1.9a.51.51 0 0 1 .166.362.507.507 0 0 1-.137.371.536.536 0 0 1-.662.083l-.072-.056-1.187-1.093v9.185c0 .307-.213.52-.518.52-.273 0-.472-.168-.513-.421l-.008-.099v-9.117l-1.092 1.094a.537.537 0 0 1-.735 0 .525.525 0 0 1-.06-.665l.06-.073 1.98-1.978.035-.03.06-.037c.016-.012.038-.029.067-.04l.049-.017.123-.024a.253.253 0 0 1 .03-.002Zm-4.748.077c.272 0 .47.168.512.42l.008.099v9.038l1.092-1.092a.518.518 0 0 1 .788.672l-.053.063-1.98 1.98a.514.514 0 0 1-.367.15.517.517 0 0 1-.305-.097l-.062-.053-1.98-1.98a.515.515 0 0 1 0-.735.522.522 0 0 1 .663-.06l.072.06 1.093 1.092v-9.038c0-.306.213-.52.519-.52Zm1.9-11.085c3.527 0 6.617 2.494 7.385 5.944 2.908.208 5.09 2.489 5.09 5.343-.079 3.007-2.433 5.464-5.293 5.582l-.215.005h-1.267a.497.497 0 0 1-.519-.52c0-.272.17-.47.42-.512l.099-.007h1.267c2.42 0 4.39-2.041 4.39-4.548 0-2.461-1.929-4.39-4.39-4.39-.282 0-.599-.187-.599-.44-.463-3.08-3.203-5.418-6.368-5.418-3.599 0-6.528 2.893-6.528 6.448L5 8.574c.006.189.023.375.075.63.002.119.002.314-.114.429-.091.093-.235.111-.337.115h-.146a3.443 3.443 0 0 0-3.439 3.44 3.444 3.444 0 0 0 3.25 3.434l.189.005h2.296c.306 0 .52.213.52.52 0 .27-.17.47-.422.511l-.098.008H4.478C2.051 17.666 0 15.614 0 13.188c0-2.237 1.587-4.054 3.82-4.433l.218-.032v-.828a7.113 7.113 0 0 1 2.055-4.85C7.518 1.592 9.447.792 11.525.792Z",
    clipRule: "evenodd"
  })]
});